export default __webpack_public_path__ + "static/media/illustrationRegister1.2ecb919c.png";